import { AxiosRequestConfig } from 'axios';
import { axiosInstance } from './axios-instance';
import { authInstance } from './auth-instance';

/**
 * Dispatcher: use authAxios for /admin/*, axios for everything else.
 * Orval uses this as the mutator.
 */
export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  if (config.url?.startsWith('/admin')) {
    return authInstance<T>(config, options);
  }
  return axiosInstance<T>(config, options);
};

export type ErrorType<Error> = import('axios').AxiosError<Error>;
export type BodyType<BodyData> = BodyData;
